<template>
  <div class="orm-col-xs-12 orm-col-md-4 orm-col-lg-3">
    <div class="orm-carfilter_abo orm-mr-xs-0 orm-mr-lg-56 orm">
      <h2 class="orm-headline__h3 orm-mb-16">
        Konfiguriere dein neues Auto
      </h2>
      <filterSelect
          v-if="vehicleGroups"
          :groupFilter="vehicleGroups"
          :preselect="selectedVehicleGroups"
          @update:dataPool="updateFilter($event, 'vehicleGroup')"
          filterType="vehicleGroup"
          :hideSelection="true"
          :title="
                    i18n('step1/abofilter/vehicleGroup') || 'Fahrzeuggruppe'
                  "
          class="orm-dropbox_round"
      />
      <filterSelect
          :groupFilter="manufacturers"
          :preselect="selectedManufacturers"
          @update:dataPool="updateFilter($event, 'manufacturer')"
          filterType="manufacturers"
          :hideSelection="true"
          :title="i18n('step1/abofilter/manufacturer') || 'Marke'"
          class="orm-dropbox_round"
      />
      <filterSelect
          :groupFilter="models"
          :preselect="selectedModels"
          @update:dataPool="updateFilter($event, 'model')"
          filterType="models"
          :hideSelection="true"
          :title="i18n('step1/abofilter/model') || 'Modell'"
          class="orm-dropbox_round"
          :class="models.length == 0 ? 'disabled' : ''"
          :disabled="models.length === 0"
      />
      <filterSelect
          :groupFilter="durations"
          :preselect="selectedDurations"
          @update:dataPool="updateFilter($event, 'duration')"
          filterType="durations"
          :hideSelection="true"
          :title="i18n('step1/abofilter/duration') || 'Laufzeit'"
          class="orm-dropbox_round"
          :class="durations.length == 0 ? 'disabled' : ''"
          :disabled="durations.length === 0"
      />
      <filterSelect
          :groupFilter="fuelTypes"
          :preselect="selectedFuelTypes"
          @update:dataPool="updateFilter($event, 'fueltype')"
          filterType="fuelType"
          :hideSelection="true"
          :title="i18n('step1/abofilter/fueltype') || 'Kraftstoff'"
          class="orm-dropbox_round"
      />
      <filterSelect
          :groupFilter="colors"
          :preselect="selectedColors"
          @update:dataPool="updateFilter($event, 'color')"
          filterType="colors"
          :hideSelection="true"
          :title="i18n('step1/abofilter/color') || 'Farbe'"
          class="orm-dropbox_round"
      />
      <filterSelect
          :groupFilter="gears"
          :preselect="selectedGears"
          @update:dataPool="updateFilter($event, 'gear')"
          filterType="gear"
          :hideSelection="true"
          :title="i18n('step1/abofilter/gear') || 'Getriebe'"
          class="orm-dropbox_round"
      />
      <filterSelect
          :groupFilter="subscriptionEquipments"
          :preselect="selectedSubscriptionEquipments"
          @update:dataPool="
                    updateFilter($event, 'subscriptionEquipment')
                  "
          filterType="subscriptionEquipmentsV2"
          :hideSelection="true"
          :title="
                    i18n('step1/abofilter/subscriptionEquipment') ||
                      'Ausstattung'
                  "
          class="orm-dropbox_round"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import i18n from "@/mixins/mixins";
import filterSelect from "@/components/ui/filter-select.vue";

export default defineComponent({
  name: "VehicleFilter",
  mixins: [i18n],
  components: {
    filterSelect,
  },
  props: {
    manufacturers: {
      type: Array,
      default: () => []
    },
    durations: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Array,
      default: () => []
    },
    gears: {
      type: Array,
      default: () => []
    },
    vehicleGroups: {
      type: Array,
      default: () => []
    },
    fuelTypes: {
      type: Array,
      default: () => []
    },
    models: {
      type: Array,
      default: () => []
    },
    subscriptionEquipments: {
      type: Array,
      default: () => []
    },
    selectedManufacturers: {
      type: Object,
      default: () => ({})
    },
    selectedDurations: {
      type: Object,
      default: () => ({})
    },
    selectedColors: {
      type: Object,
      default: () => ({})
    },
    selectedFuelTypes: {
      type: Object,
      default: () => ({})
    },
    selectedGears: {
      type: Object,
      default: () => ({})
    },
    selectedVehicleGroups: {
      type: Object,
      default: () => ({})
    },
    selectedModels: {
      type: Object,
      default: () => ({})
    },
    selectedSubscriptionEquipments: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['filter-changed'],
  methods: {
    updateFilter(ev, type) {
      const filteredObject = Object.fromEntries(
        Object.entries(ev.selectedGroup).filter(
          ([key, value]) => value === true
        )
      );

      this.$emit('filter-changed', {
        type: type,
        selectedItems: filteredObject,
        eventData: ev
      });
    }
  }
});
</script>